export const getMissionTitle = ({
  isParticipating,
  month,
  dday,
}: {
  isParticipating?: boolean
  month: number
  dday: number
}) => {
  if (dday <= 10) {
    return { title: `${month}월 미션 종료 D-${dday}!` }
  }

  if (!isParticipating) {
    return { title: `${month}월 신규 미션 오픈!`, description: '리뷰 작성하고 미션에 참여해보세요!' }
  }

  return {
    title: `${month}월 미션 완주해볼까요?`,
  }
}
